import React, { useState, useEffect, } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import PropTypes from 'prop-types';
import Delete from '@mui/icons-material/Delete';
import axios from 'src/utils/axios';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import {
  Box,
  IconButton,
  SvgIcon,
} from '@mui/material';
import {
  Image as ImageIcon,
  Edit as EditIcon,
  ArrowRight as ArrowRightIcon,
  Search as SearchIcon
} from 'react-feather';

import { useDispatch } from 'react-redux';

function Results({ className, services, businessInfo, ...rest }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {

  }, [services]);

  const handleDelete = async (customerId, serviceId) => {
    // console.log("ServiceID", serviceId);
    try {
      const payload = {
        "customerId": customerId,
        "serviceId": serviceId
      }
      // const deleteResult = await axios.post(`/api/admin/customer/info/delete/news`, payload);
      
      // dispatch(fetchNews(customerId));
    } catch (err) { }
  };

  const columns = [
    // { field: 'customerId', headerName: 'customerId', width: 100 },
    { field: 'serviceId', headerName: 'Service Id', width: 80 },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Tooltip title="Edit News">
              <IconButton
                onClick={() => {
                  navigate('/app/management/news/edit', { state: params.row });
                }
                }
              >
                <SvgIcon fontSize="small">
                  <EditIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <m>
              <Tooltip title="Delete Service">
                <IconButton
                  onClick={() => handleDelete(params.row.customerId, params.row.serviceId)}
                >
                  <SvgIcon fontSize="small">
                    <Delete />
                  </SvgIcon>
                </IconButton>
              </Tooltip></m>
          </div>
        );
      },
    },
    { field: 'serviceName', headerName: 'Service Name', width: 200 },
    { field: 'description', headerName: 'Description', width: 200 },
    { field: 'videoLink', headerName: 'Video Url', width: 200 },
    { field: 'createdAt', headerName: 'Created Date', width: 200 },
    
  ];

  return (
    <Box sx={{ height: 400, width: '100%', padding: 2}}>
      <DataGrid
        rows={services}
        columns={columns}
        getRowId={(row) => row.serviceId}
        // checkboxSelection={true}
        pageSize={10}
        rowsPerPageOptions={[10,25]}
      />
    </Box>
  )
}

Results.propTypes = {
  className: PropTypes.string,
  services: PropTypes.array
};

Results.defaultProps = {
  services: []
};

export default Results;